import { render, staticRenderFns } from "./PlantList.vue?vue&type=template&id=5fbf0ad9&scoped=true"
import script from "./PlantList.vue?vue&type=script&lang=ts"
export * from "./PlantList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf0ad9",
  null
  
)

export default component.exports